import { HANDLE_START_LOADER, HANDLE_COMPLETE_LOADER } from './index'

export const handleStartLoaderAction: Types.ActionFactory = () => ({
  type: HANDLE_START_LOADER,
})

export const handleCompleteLoaderAction: Types.ActionFactory = () => ({
  type: HANDLE_COMPLETE_LOADER,
})
